/** Default [alignOffset, sideOffset] passed to `DropdownMenuContent`. */
export const MENU_OFFSET: [number, number] = [0, 0];
